import { z } from 'zod';
export var FeaturesEnum;
(function (FeaturesEnum) {
    FeaturesEnum["DASHBOARD"] = "DASHBOARD";
    FeaturesEnum["POINT_OF_SALE"] = "POINT_OF_SALE";
    FeaturesEnum["POINT_OF_SALE_V3"] = "POINT_OF_SALE_V3";
    FeaturesEnum["POINT_OF_SALE_RESTAURANT"] = "POINT_OF_SALE_RESTAURANT";
    FeaturesEnum["TRANSACTIONS"] = "TRANSACTIONS";
    FeaturesEnum["TRANSACTIONS_V4"] = "TRANSACTIONS_V4";
    FeaturesEnum["INVENTORY"] = "INVENTORY";
    FeaturesEnum["INVENTORY_V4"] = "INVENTORY_V4";
    FeaturesEnum["INVENTORY_TOOLS"] = "INVENTORY_TOOLS";
    FeaturesEnum["MOBILE_INVENTORY"] = "MOBILE_INVENTORY";
    FeaturesEnum["QUICK_PAY_V4"] = "QUICK_PAY_V4";
    FeaturesEnum["REPORTS"] = "REPORTS";
    FeaturesEnum["PAYMENTS"] = "PAYMENTS";
    FeaturesEnum["INVOICES"] = "INVOICES";
    FeaturesEnum["MARKETPLACE"] = "MARKETPLACE";
    FeaturesEnum["DEBT_TRACKER"] = "DEBT_TRACKER";
    FeaturesEnum["NOTIFICATIONS"] = "NOTIFICATIONS";
    FeaturesEnum["SETTINGS"] = "SETTINGS";
    FeaturesEnum["ADMIN_PAGE"] = "ADMIN_PAGE";
    FeaturesEnum["EBT_PAYMENTS"] = "EBT_PAYMENTS";
    FeaturesEnum["ORDERS_PAGE"] = "ORDERS_PAGE";
    FeaturesEnum["CUSTOMERS_PAGE"] = "CUSTOMERS_PAGE";
    FeaturesEnum["PAYMENTS_PAGE"] = "PAYMENTS_PAGE";
    FeaturesEnum["INVOICES_PAGE"] = "INVOICES_PAGE";
    FeaturesEnum["CASH_APP_PAGE"] = "CASH_APP_PAGE";
    FeaturesEnum["MENU"] = "MENU";
})(FeaturesEnum || (FeaturesEnum = {}));
export var PermissionsEnum;
(function (PermissionsEnum) {
    PermissionsEnum["REFUND_POS_CHECKOUT"] = "REFUND_POS_CHECKOUT";
    PermissionsEnum["DELETE_POS_CHECKOUT"] = "DELETE_POS_CHECKOUT";
    PermissionsEnum["EDIT_POS_CHECKOUT"] = "EDIT_POS_CHECKOUT";
    PermissionsEnum["USE_SPLIT_PAYMENTS"] = "USE_SPLIT_PAYMENTS";
    //customer permissions
    PermissionsEnum["CAN_USE_CUSTOMER_DETAILS"] = "CAN_USE_CUSTOMER_DETAILS";
    PermissionsEnum["REPORTS_REQUIRE_STORE_ADMIN"] = "REPORTS_REQUIRE_STORE_ADMIN";
    PermissionsEnum["CASH_DRAWER_REQUIRE_ADMIN"] = "CASH_DRAWER_REQUIRE_ADMIN";
    PermissionsEnum["CAN_GIVE_PARTIAL_REFUNDS"] = "CAN_GIVE_PARTIAL_REFUNDS";
    PermissionsEnum["CAN_MAKE_MANUAL_PAYMENTS"] = "CAN_MAKE_MANUAL_PAYMENTS";
    PermissionsEnum["CAN_MAKE_BNPL_PAYMENTS"] = "CAN_MAKE_BNPL_PAYMENTS";
    PermissionsEnum["ENABLE_VOID_REFUND_BUTTON"] = "ENABLE_VOID_REFUND_BUTTON";
    PermissionsEnum["ENABLE_TIP_SELECTION_BUTTON"] = "ENABLE_TIP_SELECTION_BUTTON";
    PermissionsEnum["DEFAULT_TERMINAL_TO_MANUAL_PAYMENTS"] = "DEFAULT_TERMINAL_TO_MANUAL_PAYMENTS";
    PermissionsEnum["CAN_USE_INVENTORY_FLOW"] = "CAN_USE_INVENTORY_FLOW";
    PermissionsEnum["CAN_USE_MEAL_FLOW"] = "CAN_USE_MEAL_FLOW";
    PermissionsEnum["CAN_MAKE_EBT_PAYMENTS"] = "CAN_MAKE_EBT_PAYMENTS";
    PermissionsEnum["CAN_USE_WIC_PAYMENTS"] = "CAN_USE_WIC_PAYMENTS";
    PermissionsEnum["CAN_USE_EBT_CASH_PAYMENTS"] = "CAN_USE_EBT_CASH_PAYMENTS";
    PermissionsEnum["CAN_VIEW_STORE_REPORT"] = "CAN_VIEW_STORE_REPORT";
    // Auth V2: approve trusted business-device pairing requests
    PermissionsEnum["BUSINESS_DEVICE_PAIR_APPROVE"] = "BUSINESS_DEVICE_PAIR_APPROVE";
})(PermissionsEnum || (PermissionsEnum = {}));
export var AccountTypes;
(function (AccountTypes) {
    AccountTypes["BUSINESS"] = "BUSINESS";
    AccountTypes["USER"] = "USER";
    AccountTypes["ADMIN"] = "ADMIN";
    AccountTypes["TERMINAL"] = "TERMINAL";
    // Auth V2: first-class trusted device identity (iPad POS, kiosk, payment terminal)
    AccountTypes["BUSINESS_DEVICE"] = "BUSINESS_DEVICE";
})(AccountTypes || (AccountTypes = {}));
export var UserAccountType;
(function (UserAccountType) {
    // SUPER_ADMIN = 'super_admin',
    UserAccountType["BUSINESS_VIEWER"] = "BUSINESS_VIEWER";
    UserAccountType["BUSINESS_MANAGER"] = "BUSINESS_MANAGER";
    UserAccountType["BUSINESS_ADMIN"] = "BUSINESS_ADMIN";
    UserAccountType["BUSINESS_CUSTOMER_USER"] = "BUSINESS_CUSTOMER_USER";
})(UserAccountType || (UserAccountType = {}));
export var StoreAdminPermissionsEnum;
(function (StoreAdminPermissionsEnum) {
    StoreAdminPermissionsEnum["CAN_VIEW_SETTINGS"] = "CAN_VIEW_SETTINGS";
    StoreAdminPermissionsEnum["CAN_VIEW_REPORTS"] = "CAN_VIEW_REPORTS";
    StoreAdminPermissionsEnum["CAN_GIVE_REFUNDS"] = "CAN_GIVE_REFUNDS";
})(StoreAdminPermissionsEnum || (StoreAdminPermissionsEnum = {}));
export var UserPermissionsEnum_Pos;
(function (UserPermissionsEnum_Pos) {
    UserPermissionsEnum_Pos["CAN_VIEW_DASHBOARD"] = "CAN_VIEW_DASHBOARD";
    UserPermissionsEnum_Pos["CAN_MANAGE_INVENTORY"] = "CAN_MANAGE_INVENTORY";
    UserPermissionsEnum_Pos["CAN_VIEW_REPORTS"] = "CAN_VIEW_REPORTS";
})(UserPermissionsEnum_Pos || (UserPermissionsEnum_Pos = {}));
export var UserPermissionsEnum_Web;
(function (UserPermissionsEnum_Web) {
    UserPermissionsEnum_Web["CAN_VIEW_DASHBOARD"] = "CAN_VIEW_DASHBOARD";
    UserPermissionsEnum_Web["CAN_VIEW_REPORTS"] = "CAN_VIEW_REPORTS";
    UserPermissionsEnum_Web["CAN_MANAGE_CUSTOMERS"] = "CAN_MANAGE_CUSTOMERS";
    UserPermissionsEnum_Web["CAN_MANAGE_EMPLOYEES"] = "CAN_MANAGE_EMPLOYEES";
    UserPermissionsEnum_Web["CAN_CREATE_PAYMENTS"] = "CAN_CREATE_PAYMENTS";
})(UserPermissionsEnum_Web || (UserPermissionsEnum_Web = {}));
// Zod Schemas
export const FeaturesSchema = z.nativeEnum(FeaturesEnum);
export const PermissionsSchema = z.nativeEnum(PermissionsEnum);
export const StoreAdminPermissionsSchema = z.nativeEnum(StoreAdminPermissionsEnum);
